import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { login, logout } from "../../redux/actions/authActions";

export default function LoginForm() {
  const dispatch = useDispatch();
  const { token, user } = useSelector((state) => state.auth);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    try {
      await dispatch(login(email, password));
    } catch (err) {
      setError(err.message);
    }
  };

  if (token) {
    return (
      <div>
        <h2>Vous êtes connecté</h2>
        {user && (
          <div>
            <p>Bienvenue, {user.firstNameUser} {user.lastNameUser}</p>
          </div>
        )}
        <button onClick={() => dispatch(logout())}>Se déconnecter</button>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit}>
      <h2>Connexion</h2>
      {error && <p style={{ color: "red" }}>{error}</p>}
      <div>
        <label>Email</label>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
      </div>
      <div>
        <label>Mot de passe</label>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
      </div>
      <button type="submit">Se connecter</button>
    </form>
  );
}
